module.exports = __webpack_public_path__ + "static/media/ic_cloud_info_24px.c787ad53.svg";